import { all, call, put, takeLatest } from "redux-saga/effects";
import { PLACEMENT_REVENUE_REPORT_REQUEST } from "./actionType";
import {
  getPlacementRevenueReportSuccess,
  getPlacementRevenueReportFail,
} from "./action";
import { placementRevenueReportAPI } from "../../helpers/fakebackend_helper";

function* getPlacementRevenueReportSaga({ payload }) {
  try {
    const response = yield call(placementRevenueReportAPI, payload);
    yield put(getPlacementRevenueReportSuccess(response));
  } catch (error) {
    yield put(getPlacementRevenueReportFail(error));
  }
}

export function* watchGetPlacementRevenueReportSaga() {
  yield takeLatest(
    PLACEMENT_REVENUE_REPORT_REQUEST,
    getPlacementRevenueReportSaga
  );
}

export default function* PlacementRevenueReportSaga() {
  yield all([watchGetPlacementRevenueReportSaga()]);
}
